// TEMPORARY: This file exports all country-specific bucket setting overrides
// This will not be needed once buckets configuration is moved to DB
// Add new overrides by importing them here and adding them to the default export
// When you create a new override file (e.g., DE.ts), import it and add it to the overrides object

import type { PartialRecursive } from '@bridebook/models/source/abstract/_';
import type { IBucket } from '@bridebook/models/source/models/Countries/Buckets.types';
import type { CountryCodes } from '@bridebook/toolbox/src/gazetteer';
import AT from './AT';
import AU from './AU';
import CA from './CA';
import CH from './CH';
import ES from './ES';
import IE from './IE';
import IT from './IT';
import NZ from './NZ';
import US from './US';
import ZA from './ZA';
import DE from './DE';
import FR from './FR';
import GB from './GB';

const overrides: Partial<Record<CountryCodes, PartialRecursive<IBucket['settings']>>> = {
  AT,
  AU,
  CA,
  CH,
  ES,
  IE,
  IT,
  NZ,
  US,
  ZA,
  DE,
  FR,
  GB,
};

export default overrides;
